import DownloadIcon from '@mui/icons-material/Download';
import { ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

import { SecondaryButton } from '../Buttons/SecondaryButton';

interface DownloadButtonProps extends ButtonProps {
  label?: string;
  fileUrl: string;
  sx?: SxProps<Theme>;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ label = 'Download Template', sx, fileUrl, ...rest }) => {
  const handleDownload = () => {
    if (!fileUrl) return;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <SecondaryButton startIcon={<DownloadIcon />} onClick={handleDownload} {...rest}>
      {label}
    </SecondaryButton>
  );
};

export { DownloadButton };
